<template>
  <div class="content-pager" v-show="total > 0">
    <div class="pagination-container" style="margin-bottom:20px">
      <el-pagination v-show="total>0" :current-page="current" :page-sizes="[10,20,30, 50]" :page-size="pageSize"
                     :total="total" background layout="total, sizes, prev, pager, next, jumper"
                     @size-change="sizeChangeFun" @current-change="gotoPage"/>
    </div>
    <!-- <ul class="pagination pagination-sm">
        <li v-if="preAble" v-on:click="gotoPage(current - 1)">
            <span>
                <span aria-hidden="true">&laquo;</span>
            </span>
        </li>
        <li v-else class="disabled">
            <span>
                <span aria-hidden="true">&laquo;</span>
            </span>
        </li>
        <li v-for="num in amount" v-bind:class="{active: num == current}" v-on:click="gotoPage(num)">
            <span>{{num}} <span class="sr-only">({{num}})</span></span>
        </li>
        <li v-if="nextAble" v-on:click="gotoPage(current + 1)">
            <span>
                <span aria-hidden="true">&raquo;</span>
            </span>
        </li>
        <li v-else class="disabled">
            <span>
                <span aria-hidden="true">&raquo;</span>
            </span>
        </li>
    </ul> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      current: 1,
      setLimit: null,
    }
  },
  props: {
    // 请求前判断
    requestBefore: {
      type: Function,
      required: false
    },
    // 数据填充
    datafile: {
      type: Function,
      required: true
    },
    // 请求url
    url: {
      type: String,
      required: true
    },
    // 查询对象
    query: {
      type: Object,
      required: true
    },
    // 提交方式
    method: {
      type: String,
      default: 'post',
      validator: function (_val) {
        return 'post' == _val || 'get' == _val;
      }
    },
    // 是否初始化
    init: {
      type: Boolean,
      default: false
    },

    // async/contentType
    contentType: {
      type: String
    },

    // 每面记录数
    limit: {
      type: Number,
      default: 20
    },
    // 当前请求页
    num: {
      type: Number,
      default: 1
    }
  },
  created() {
    this.current = this.num;
    if (this.init) {
      this.gotoPage();
    }
  },
  computed: {
    amount() {
      var _this = this;
      var pages = [];
      var gotoAmount = 10;
      var current = _this.current;
      var total = _this.total;
      var limit = _this.pageSize;
      var start = 1,
          end = gotoAmount;
      var pageCount = Math.ceil(total / limit);
      if (pageCount < gotoAmount) {
        // 当总页码小于10的时候，start为1，end为pageCount;
        end = pageCount;
      } else if (current <= gotoAmount / 2) {
        // 总页码大于10，当前页码小于等于5，start为1，end为10
        end = gotoAmount;
      } else if (current > pageCount - gotoAmount / 2) {
        // 总页码大于10，当前页码大于等于总页码数-4，start为pageCount-9，end为pageCount
        start = pageCount - gotoAmount;
        end = pageCount;
      } else {
        start = current - gotoAmount / 2;
        end = current + gotoAmount / 2 - 1;
      }
      for (var i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    preAble() {
      return this.current > 1;
    },
    nextAble() {
      return this.current * this.limit < this.total;
    },
    pageSize() {
      return this.setLimit || this.limit
    }
  },
  methods: {
    gotoPage(_num = this.current) {
      var _this = this;
      var _date = {
        limit: _this.pageSize,
        current: _num,
      };
      if(this.requestBefore){
        this.requestBefore()
      }
      Object.assign(_date, _this.query);
      // 请求数据
      _this.$common.my_ajax({
        url: _this.url,
        data: _date,
        contentType: _this.contentType,
        success: function (response) {
          _this.total = response.total;
          _this.current = _num;
          _this.datafile(response);
        }
      });
    },

    sizeChangeFun(_size) {
      this.setLimit = _size;
      this.gotoPage(1);
    }
  }
}
</script>
<style scope>
.pagination {
  margin-top: 0;
}
</style>